module.exports = __webpack_public_path__ + "static/media/title.86d2e674.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title.png
// module id = 106
// module chunks = 0